//import Moment from "moment";

const getCount = (state) => {
	return state.compartimentos.length;
}

const ultimaAtualizacaoListaCompartimentos = (state) => {
	if (state.ultimaAtualizacaoListaCompartimentos == null) {
		return true;
	}
	else if(!state.Compartimentos)
	{
		return true;
	}
	else {
		const d = new Date();
		let hour = d.getHours();
		return (
			state.compartimentos.length == 0 ||
			hour - state.ultimaAtualizacaoListaCompartimentos.getHours() > 0
		);
	}
}

export default {
	getCount,
	ultimaAtualizacaoListaCompartimentos
}